import { ModuleWithProviders, NgModule } from '@angular/core'
import { JobService } from '~app/features/job/job.service'
import { TimeRangeService } from '~app/features/recording-segment/time-range.service'
import { TranscriptFileUploadService } from '~app/features/transcript-upload/transcript-file-upload.service'

@NgModule({
  providers: [JobService],
})
export class JobServiceModule {
  static forRoot(): ModuleWithProviders<JobServiceModule> {
    return {
      ngModule: JobServiceModule,
      providers: [TranscriptFileUploadService, TimeRangeService],
    }
  }
}
